import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { SVGIcon } from 'common/components';
import './styles/slider-controls.less';

const SliderControls = ({ onClick, direction }) => {
  const classNames = useClassName('EventsSliderControls');
  const isPrev = direction === 'prev';

  return (
    <button
      className={classNames('nav')}
      onClick={onClick}
      aria-label={`${isPrev ? 'Previous' : 'Next'} slide`}>
      <SVGIcon name={`slider-arrow-${isPrev ? 'left' : 'right'}`} size="tiny" />
    </button>
  );
};

SliderControls.propTypes = {
  onClick: PropTypes.func.isRequired,
  direction: PropTypes.oneOf(['prev', 'next']).isRequired,
};

export default SliderControls;
